import React, { useContext, useEffect, useState } from "react"
import { GlobalAuthContext } from "../../context/authContext"
import { FETCH_JOBS } from "./job-actions"
import { navigate } from "gatsby"

import JobCard from "./job-card"
import Spinner from "../spinner/spinner"
import Paginator from "../paginator/paginator"
import { removeDuplicatesById } from "../../utils/removeDuplicatesById"

const JobList = ({ query_params, isGeneral }) => {
  const [loading, setLoading] = useState(true)
  const { state, dispatch } = useContext(GlobalAuthContext)
  const getJobList = async () => {
    setLoading(true)
    let qp = !!query_params?.page ? `?page=${query_params?.page}${isGeneral?'&general=true':""}` : `?page=${1}${isGeneral?'&general=true':""}`
    const res = await FETCH_JOBS(qp)
    if (res?.response?.status === 404) navigate("?page=1")
    if (res?.status === 200) {
      const filteredJobs = removeDuplicatesById(res?.data?.results)
      // const filteredJobs = res?.data?.results
      dispatch({
        type: "COMPANY_JOB_POSTED",
        payload: { ...res?.data, results: filteredJobs },
      })
      setLoading(false)
    }
  }
  const handlePageChange = page => {
    // dispatch({ type: "COMPANY_JOB_POSTED", payload: job_posted_list })
    navigate(`?page=${page + 1}`)
  }

  useEffect(() => {
    getJobList()
  }, [query_params?.page, isGeneral])
  return (
    <>
      {!loading ? (
        <>
          {state?.job_posted_list?.results?.length > 0 ? (
            state?.job_posted_list?.results?.map(job_data => {
              return (
                <div className="mb-4">
                  <JobCard job_data={job_data} key={job_data?.id} />
                </div>
              )
            })
          ) : (
            <div className="text-center">
              <h1>Sorry, no jobs found.</h1>
              {state?.user?.company?.id ? (
                <p>You haven't posted any jobs yet.</p>
              ) : (
                <></>
              )}
            </div>
          )}
          {state?.job_posted_list?.total_pages > 1 && (
            <div className="d-flex mt-4 justify-content-end">
              <Paginator
                pageCount={state?.job_posted_list?.total_pages}
                pageRangeDisplayed={2}
                selected={query_params?.page - 1 || 0}
                // onChange={page => console.log(page)}
                // onChange={page => handlePageChange(page)}
                setCurrentPage={page => handlePageChange(page)}
                initialPage={state?.job_posted_list?.pagenumber - 1}
                marginPagesDisplayed={2}
              />
            </div>
          )}
        </>
      ) : (
        <Spinner />
      )}
    </>
  )
}

export default JobList
